module.exports = __webpack_public_path__ + "assets/momentjs.c2f0df78.svg";